import {PencilSquareIcon} from '@heroicons/react/24/outline';
import Urls from '@/pages/profile/Urls';
import {useUser} from '@lore/auth';
import {useConnect} from '@lore/query-connect';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import PayloadStates from "@/constants/PayloadStates";
import {useTranslation} from 'react-i18next';

export default function OrganizationSection() {
  const {t} = useTranslation();
  const currentUser = useUser();
  const navigate = useNavigate();
  const {id: userId} = currentUser.data;

  const jobs = useConnect('job.find', {
    where: {
      eager: {
        $where: {
          userId: userId
        },
        $eager: {"organization":{}}
      },
    },
    pagination: {
      page: 1,
      pageSize: 1,
      order: 'createdAt asc'
    }
  }, {enabled: !!userId, staleTime: 0});

  const [job, setJob] = useState({});
  const [fullAddress, setFullAddress] = useState("");

  useEffect(() => {
    if (jobs.state === PayloadStates.RESOLVED) {
      if (Array.isArray(jobs.data)) {
        const firstJob = jobs.data.map(job => (
          {
            ...job.data,
            organization:job.data._eager.organization,
            _eager: undefined
          }
        )).slice(0)[0];
        setJob(firstJob);
      }
      else
        setJob(jobs.data);
    }
  }, [jobs.state, jobs.data]);

  useEffect(() => {
    if (jobs.state !== PayloadStates.RESOLVED) return;
    if (!job) return;

    const street = [
      job.organization?.addressLine1,
      job.organization?.addressLine2,
      job.organization?.addressLine3].filter(Boolean).join(' ')
    const csz = [
      job.organization?.city,
      job.organization?.state,
      job.organization?.zipCode].filter(Boolean).join(', ')
    setFullAddress(`${street}\n${csz}`);
  }, [job, jobs.state]);

  function navigateToUserOrganizations() {
    navigate(Urls(currentUser).ORGANIZATIONS, {
      state: { returnPath: `${Urls(currentUser).PROFILE_EDIT}#location` }
    });
  }

  return (
    <div  className="grid items-start gap-2">
      <div className="mb-2 flex items-center space-x-3">
        <h4 className="text-base font-semibold text-cs-gray-900">{t('organizations.title')}</h4>
        <button
          type="button"
          className="text-cs-blue-500 hover:opacity-60"
          aria-label={t('organizations.editAriaLabel')}
          onClick={navigateToUserOrganizations}
        >
          <PencilSquareIcon className="size-5"/>
        </button>
      </div>
      <div>
        {job ? (
          <div className="space-y-1 text-base text-cs-gray-500">
            <p>{job.organization?.name}</p>
            <p >{job.title}</p>
            <p className="whitespace-pre-line">
              {fullAddress}
            </p>
          </div>
        ) : <div>{t('organizations.emptyState')}</div>}
      </div>
    </div>
  );
}
